import MakeKey from "../../../commons/services/MakeKey";

export function generateCarrierKey(deviceList) {
	const uniqueCarrierList = []; // { key: `${siteNo}-${rtuNo}`, siteNo, rtuNo, deviceNos: [] }

	// deviceList에서 siteNo, rtuNo가 중복되지 않는 데이터만 추출 (deviceNos: 해당 siteNo, rtuNo에 해당하는 deviceNo들)
	deviceList.forEach((device) => {
		const { siteNo, deviceNo, rtuNo } = device;
		const key = `${siteNo}-${rtuNo}-${deviceNo}`;
		const findIdx = uniqueCarrierList.findIndex((carrier) => carrier.key === key);
		if (findIdx === -1) {
			uniqueCarrierList.push({
				key,
				siteNo,
				rtuId: rtuNo,
				deviceNo: deviceNo,
			});
		}
	});

	const uniqueCarrierKeyList = [];
	uniqueCarrierList.forEach((carrier) => {
		const { siteNo, rtuId, deviceNo } = carrier;
		const key = MakeKey.carrier({ siteNo, rtuNo: rtuId, deviceNo });
		uniqueCarrierKeyList.push(key);
	});
	return uniqueCarrierKeyList;
}
